import Layout from "@/page/index/";
// import newActive from "@/views/macketingActives/newActive/index"

export default [
  {
    path: "/info",
    component: Layout,
    redirect: "/info/index",
    children: [
      {
        path: "index",
        name: "个人信息",
        component: () =>
          import(/* webpackChunkName: "page" */ "@/views/admin/user/info"),
      },
    ],
  },
  {
    path: "/activti",
    component: Layout,
    redirect: "/activti/detail",
    children: [
      {
        path: "detail/:id",
        component: () =>
          import(/* webpackChunkName: "views" */ "@/views/activiti/detail"),
      },
    ],
  },
  // 菜品详情
  {
    path: "/recordManage/food",
    component: Layout,
    redirect: "/recordManage/food/goods-details",
    children: [
      {
        path: "goods-details/:id",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/recordManage/food/goods-details"
          ),
      },
    ],
  },
  // 商品详情
  {
    path: "/recordManage/good",
    component: Layout,
    redirect: "/recordManage/good/goods-details",
    children: [
      {
        path: "goods-details/:id",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/recordManage/good/goods-details"
          ),
      },
    ],
  },

  // // 商品订单详情
  // {
  //   path: "/orderManager/order",
  //   component: Layout,
  //   redirect: "/orderManager/order/order-details",
  //   children: [
  //     {
  //       path: "order-details/:id",
  //       component: () =>
  //         import(
  //           /* webpackChunkName: "views" */ "@/views/orderManager/order/order-details"
  //         ),
  //     },
  //   ],
  // },

  // 商品订单详情
  {
    path: "/orderManager/order",
    component: Layout,
    redirect: "/orderManager/order/new-order-details",
    children: [
      {
        path: "new-order-details/:id",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/orderManager/order/new-order-details"
          ),
      },
    ],
  },
  // 订单重构
  {
    path: "/orderManager/order-details",
    component: Layout,
    children: [
      {
        path: "index/:id",
        component: () => import("@/views/orderManager/order-details/index"),
      },
    ],
  },
  // 支付订单详情
  {
    path: "/orderManager/payOrder",
    component: Layout,
    redirect: "/orderManager/payOrder/pay-details",
    children: [
      {
        path: "pay-details/:id",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/orderManager/payOrder/pay-details"
          ),
      },
    ],
  },
  //----查看菜品详情
  {
    path: "/recordManage/food",
    component: Layout,
    children: [
      ///:id
      {
        path: "foods-details/:id",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/recordManage/food/foods-details"
          ),
      },
    ],
  },
  //----查看菜品详情
  // {
  //   path:"/recordManage",
  //   component:Layout,
  //   // redirect: "/recordManage/food/foods-details",
  //   children:[
  //     ///:id
  //     {
  //       path: "food/foods-details",
  //       component: () =>
  //         import(
  //           /* webpackChunkName: "views" */ "@/views/recordManage/food/foods-details"
  //         ),
  //     },
  //   ]
  // },
  // 退款详情
  {
    path: "/orderManager/refund",
    component: Layout,
    redirect: "/orderManager/refund/refund-details",
    children: [
      {
        path: "refund-details/:id",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/orderManager/refund/refund-details"
          ),
      },
    ],
  },
  // 批量操作
  {
    path: "/orderManager/batch-operate",
    component: Layout,
    children: [
      {
        path: "shop-responsibility-cancel-setting",
        name: "设置商家违约",
        component: () =>
          import(
            "@/views/orderManager/batchOperate/shop-responsibility-cancel-setting"
          ),
      },
    ],
  },

  // 客户详情
  {
    path: "/admin/customer",
    component: Layout,
    redirect: "/admin/customer/customer-details",
    children: [
      {
        path: "customer-details/:id",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/admin/customer/customer-details"
          ),
      },
    ],
  },

  // 优惠券详情
  // {
  //   path: "/coupon/coupon",
  //   component: Layout,
  //   redirect: "/coupon/list/coupon-details",
  //   children: [
  //     {
  //       path: "coupon-details/:id",
  //       component: () =>
  //         import(
  //           /* webpackChunkName: "views" */ "@/views/coupon/list/coupon-details"
  //         ),
  //     },
  //   ],
  // },

  // 取餐记录详情
  {
    path: "/takeManage/record",
    component: Layout,
    redirect: "/takeManage/record/record-details",
    // meta:{
    //   'keepAlive':true,
    // },
    children: [
      {
        path: "record-details/:id",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/takeManage/record/record-details"
          ),
      },
    ],
  },

  // 取餐异常详情
  {
    path: "/takeManage/abnormal",
    component: Layout,
    redirect: "/takeManage/abnormal/abnormal-details",
    children: [
      {
        path: "abnormal-details/:id",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/takeManage/abnormal/abnormal-details"
          ),
      },
    ],
  },

  // 预定详情
  {
    path: "/takeManage/list",
    component: Layout,
    redirect: "/takeManage/list/work-order",
    children: [
      {
        path: "takeManage-details/:id",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/takeManage/list/work-order"
          ),
      },
    ],
  },

  // 工单详情
  {
    path: "/workOrder/workOrderDetail",
    component: Layout,
    redirect: "/workOrder/workOrderDetail/index",
    children: [
      {
        path: "index/:id",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/workOrder/workOrderDetail/index"
          ),
      },
    ],
  },

  // 餐柜监控详情
  {
    path: "/cupboardMonitor/monitoringWork",
    component: Layout,
    redirect: "/cupboardMonitor/monitoringWork/monitoringWorkDetail",
    children: [
      {
        path: "monitoringWorkDetail",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/cupboardMonitor/monitoringWork/monitoringWorkDetail"
          ),
      },
    ],
  },
  // 查看活动详情
  {
    path: "/marketingActivities",
    component: Layout,
    children: [
      {
        // 新建活动
        path: "newActive/index",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/marketingActivities/newActive/index"
          ),
      },
      {
        path: "activeDetail/index",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/marketingActivities/activeDetail/index"
          ),
      },
    ],
  },
  // 打卡活动
  {
    path: "/marketingActivities/checkInActivity",
    component: Layout,
    children: [
      {
        path: "detail",
        name: "打卡详情",
        component: () =>
          import("@/views/marketingActivities/checkInActivity/detail"),
      },
    ],
  },
  // // 工单详情
  // {
  //   path: "/workOrder/workOrderDetail",
  //   component: Layout,
  //   redirect: "/workOrder/workOrderDetail/index",
  //   children: [
  //     {
  //       path: "index/:id",
  //       component: () =>
  //         import(
  //             /* webpackChunkName: "views" */ "@/views/workOrder/workOrderDetail/index"
  //         ),
  //     },
  //   ],
  // },

  // 套餐机烹煮详情
  // {
  //   path: "/processManagement/processSuitMeal",
  //   component: Layout,
  //   children: [
  //     {
  //       path: "suitMealDetail/:id",
  //       component: () =>
  //         import(
  //             /* webpackChunkName: "views" */ "@/views/processManagement/processSuitMeal/suitMealDetail"
  //         ),
  //     },
  //   ],
  // },

  //测试qurey传参数
  // {
  //    path:"/processManagement/processSuitMeal",
  //    component:Layout,
  //    children:[
  //     {
  //       path:"showTable",
  //       name:"Textshowtable",
  //       component: () =>
  //       import(
  //           /* webpackChunkName: "views" */ "@/views/processManagement/processSuitMeal/showTable"
  //       ),
  //     }
  //    ]
  // }
  //   {
  //    path:"/processManagement/processSuitMeal/showTable",
  //    name:"showTableText",
  //    component: () =>
  //    import(
  //        /* webpackChunkName: "views" */ "@/views/processManagement/processSuitMeal/showTable"
  //    ),
  // }

  // 套餐机工艺模板详情
  {
    path: "/processManagement/processTemplate",
    component: Layout,
    children: [
      {
        path: "suit-demo",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/processManagement/processTemplate/suit-demo"
          ),
      },
    ],
  },

  //----烹煮详情
  {
    path: "/processManagement/processSuitMeal",
    component: Layout,
    children: [
      {
        path: "newSuitMealDetail/:id",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/processManagement/processSuitMeal/newSuitMealDetail"
          ),
      },
    ],
  },

  //----简餐机模板详情
  {
    path: "/processManagement/processTemplate",
    component: Layout,
    children: [
      {
        path: "simple-demo",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/processManagement/processTemplate/simple-demo"
          ),
      },
    ],
  },

  //----餐柜计划详情
  {
    path: "/shopOperate/launch-plan",
    component: Layout,
    children: [
      {
        path: "shopPlanDetail",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/shopOperate/launch-plan/shopPlanDetail"
          ),
      },
    ],
  },
  // 商品管理-在售商品
  {
    path: "/shopOperate/goodsOnSale",
    component: Layout,
    children: [
      {
        path: "groundByHand",
        name: "手动上架",
        component: () => import("@/views/shopOperate/goodsOnSale/groundByHand"),
      },
      {
        path: "editShopGoods",
        name: "编辑商品",
        component: () =>
          import("@/views/shopOperate/goodsOnSale/editShopGoods"),
      },
      {
        path: "addShopGoods",
        name: "添加商品",
        component: () => import("@/views/shopOperate/goodsOnSale/addShopGoods"),
      },
      {
        path: "batchShelves",
        name: "批量上架",
        component: () => import("@/views/shopOperate/goodsOnSale/batchShelves"),
      },
    ],
  },
  // 商品管理-销售计划
  {
    path: "/shopOperate/salePlan",
    component: Layout,
    children: [
      {
        path: "addSalePlan",
        name: "新建",
        component: () => import("@/views/shopOperate/salePlan/addSalePlan"),
      },
      {
        path: "editSalePlan",
        name: "编辑",
        component: () => import("@/views/shopOperate/salePlan/editSalePlan"),
      },
    ],
  },
  // 商品管理-礼包商品
  {
    path: "/shopOperate/giftGoods",
    component: Layout,
    children: [
      {
        path: "addGiftGoods",
        name: "新建礼包商品",
        component: () => import("@/views/shopOperate/giftGoods/add-gift-goods"),
      },
      {
        path: "editGiftGoods",
        name: "编辑礼包商品",
        component: () =>
          import("@/views/shopOperate/giftGoods/edit-gift-goods"),
      },
      {
        path: "aloneInventoryManage",
        name: "礼包-独立库存-管理",
        component: () =>
          import("@/views/shopOperate/giftGoods/alone-inventory-manage"),
      },
      {
        path: "shareInventoryManage",
        name: "礼包-共享库存-管理",
        component: () =>
          import("@/views/shopOperate/giftGoods/share-inventory-manage"),
      },
    ],
  },
  // 商品管理-自提商品
  {
    path: "/shopOperate/selfPickGoods",
    component: Layout,
    children: [
      {
        path: "addSelfPickGoods",
        name: "新建自提商品",
        component: () =>
          import("@/views/shopOperate/selfPickGoods/add-self-pick-goods"),
      },
      {
        path: "editSelfPickGoods",
        name: "编辑自提商品",
        component: () =>
          import("@/views/shopOperate/selfPickGoods/edit-self-pick-goods"),
      },
      {
        path: "aloneInventoryManage",
        name: "自提-独立库存-管理",
        component: () =>
          import("@/views/shopOperate/selfPickGoods/alone-inventory-manage"),
      },
      {
        path: "shareInventoryManage",
        name: "自提-共享库存-管理",
        component: () =>
          import("@/views/shopOperate/selfPickGoods/share-inventory-manage"),
      },
    ],
  },
  // 蒸箱工艺详情
  {
    path: "/steamerManage",
    component: Layout,
    children: [
      {
        path: "steamerDetails/:id",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/steamerManage/steamerDetails"
          ),
      },
    ],
  },
  {
    path: "/steamerManage",
    component: Layout,
    children: [
      {
        path: "steamerDetails",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/steamerManage/steamerDetails"
          ),
      },
    ],
  },
  //----导入excle****计划
  {
    path: "/coupon/couponList",
    component: Layout,
    children: [
      {
        path: "importExcel",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/coupon/couponList/importExcel"
          ),
      },
    ],
  },
  //----批量发券
  {
    path: "/coupon/couponList",
    component: Layout,
    children: [
      {
        path: "batchTest",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/coupon/couponList/batchTest"
          ),
      },
    ],
  },
  //----批量详情
  {
    path: "/coupon/couponList",
    component: Layout,
    children: [
      {
        path: "batchDetails",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/coupon/couponList/batchDetails"
          ),
      },
    ],
  },
  //----兑换码
  {
    path: "/coupon/grant",
    component: Layout,
    children: [
      {
        path: "cdkeyCoupon",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/coupon/grant/cdkeyCoupon"
          ),
      },
    ],
  },
  //----单独发券
  {
    path: "/coupon/couponList",
    component: Layout,
    children: [
      {
        path: "sendCoupon",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/coupon/couponList/sendCoupon"
          ),
      },
    ],
  },
  //----菜品详情
  {
    path: "/recordManage/food",
    component: Layout,
    children: [
      {
        path: "reFood-details",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/recordManage/food/reFood-details"
          ),
      },
    ],
  },
  //----店铺日历
  {
    path: "/recordManage/shop",
    component: Layout,
    children: [
      {
        path: "shopCalendar",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/recordManage/shop/shopCalendar"
          ),
      },
    ],
  },
  //---- 消息推送计划详情
  {
    path: "/pullMsgManage/toPullMsg",
    component: Layout,
    children: [
      {
        path: "detailPull",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/pullMsgManage/toPullMsg/detailPull"
          ),
      },
    ],
  },
  //----内容变表单 contentManage
  {
    path: "/contentManage/content-demo-form",
    component: Layout,
    redirect: "/contentManage/content-demo-form/index",
    children: [
      {
        path: "index",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/contentManage/content-demo-form/index"
          ),
      },
    ],
  },
  //----店铺
  {
    path: "/report",
    component: Layout,
    children: [
      {
        path: "shopSellReport/shopNumDetail",
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/report/shopSellReport/shopNumDetail"
          ),
      },
    ],
  },
  //--- 店铺详情页面
  {
    path: "/recordManage",
    component: Layout,
    children: [
      {
        path: "shop/shop-manage-page/shop-page-detail",
        component: () =>
          import("@/views/recordManage/shop/shop-manage-page/shop-page-detail"),
      },
    ],
  },
  {
    path: "/cupboardMonitor/upgrade/setPage",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import("@/views/cupboardMonitor/upgrade/setPage/index"),
      },
    ],
  },
  //----软件升级新页面
  {
    path: "/cupboardMonitor/upgrade/setPage",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import("@/views/cupboardMonitor/upgrade/setPage/index"),
      },
    ],
  },
  //----商品详情页面
  {
    path: "/recordManage/good/good-detail",
    component: Layout,
    children: [
      {
        path: "index",
        component: () => import("@/views/recordManage/good/good-detail/index"),
      },
    ],
  },
  // 一代机商品档案
  {
    path: "/recordManage/good/good-detail",
    component: Layout,
    children: [
      {
        path: "indexForV1",
        component: () =>
          import("@/views/recordManage/good/good-detail/indexForV1"),
      },
    ],
  },
  //----商品排序页面
  {
    path: "/recordManage/good/good-sort-page",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import("@/views/recordManage/good/good-sort-page/index"),
      },
    ],
  },
  //----标签详情页面
  {
    path: "/recordManage/tag/tag-detail-page",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import("@/views/recordManage/tag/tag-detail-page/index"),
      },
    ],
  },
  //----曲线分析页面
  {
    path: "/workOrder/curveAnalysisPage",
    component: Layout,
    children: [
      {
        path: "index",
        component: () => import("@/views/workOrder/curveAnalysisPage/index"),
      },
    ],
  },
  //---礼包重发页
  {
    path: "/orderManager/order-details/order-gift-list-page",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import(
            "@/views/orderManager/order-details/order-gift-list-page/index"
          ),
      },
    ],
  },
  //--- 新建鳄币商品
  {
    path: "/shopOperate/eCoinMall/coinMallDetailPage",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import("@/views/shopOperate/eCoinMall/coinMallDetailPage/index"),
      },
    ],
  },
  //--- 内容展示详情页
  {
    path: "/contentManage/panel-adsense/adsense-page",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import("@/views/contentManage/panel-adsense/adsense-page/index"),
      },
    ],
  },
  // 优惠券详情页
  {
    path: "/coupon/list/coupon-detail",
    component: Layout,
    children: [
      {
        path: "index",
        component: () => import("@/views/coupon/list/coupon-detail/index"),
      },
    ],
  },
  // 营收日报详情页
  {
    path: "/dataStatistics/revenueDailyReport/revenueDailyReportDetail",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import(
            "@/views/dataStatistics/revenueDailyReport/revenueDailyReportDetail/index"
          ),
      },
    ],
  },
  // 营收日报详情页
  {
    path: "/dataStatistics/dailyCook",
    component: Layout,
    children: [
      {
        path: "index",
        component: () => import("@/views/dataStatistics/dailyCook/index"),
      },
    ],
  },
  // 小程序
  {
    path: "/dataStatistics/MiniappMealComboSalesDaily",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import("@/views/dataStatistics/MiniappMealComboSalesDaily/index"),
      },
    ],
  },
  // 优惠券
  {
    path: "/dataStatistics/CouponUsageDaily",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import("@/views/dataStatistics/CouponUsageDaily/index"),
      },
    ],
  },
  // 库存日报
  {
    path: "/dataStatistics/dailyStock",
    component: Layout,
    children: [
      {
        path: "index",
        component: () => import("@/views/dataStatistics/dailyStock/index"),
      },
    ],
  },
  // 编辑门店商品
  {
    path: "/shopOperate/shopGoodsManageV3/editShopGoods",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import("@/views/shopOperate/shopGoodsManageV3/editShopGoods/index"),
      },
    ],
  },
  // 门店商品任务下发详情
  {
    path: "/shopOperate/goodsDispatch/goodsPartnerDispatchDetail",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import(
            "@/views/shopOperate/goodsDispatch/goodsPartnerDispatchDetail/index"
          ),
      },
    ],
  },
  // 门店商品-合伙人-任务下发详情
  {
    path: "/shopOperate/goodsDispatch/goodsDispatchDetail",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import("@/views/shopOperate/goodsDispatch/goodsDispatchDetail/index"),
      },
    ],
  },
  // 门店新建任务详情
  {
    path: "/shopOperate/goodsDispatch/setGoodsDispatch",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import("@/views/shopOperate/goodsDispatch/setGoodsDispatch/index"),
      },
    ],
  },
  // 新建合伙人商品详情
  {
    path: "/shopOperate/goodsDispatch/setPartnerGoodsDispatch",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import(
            "@/views/shopOperate/goodsDispatch/setPartnerGoodsDispatch/index"
          ),
      },
    ],
  },
  // 门店商品排序
  {
    path: "/shopOperate/shopGoodsManageV3/sortShopGoods",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import("@/views/shopOperate/shopGoodsManageV3/sortShopGoods/index"),
      },
    ],
  },
  // 新建/编辑订货单
  {
    path: "/stockManage/ShopIndent",
    component: Layout,
    children: [
      {
        path: "addIndent",
        name: "新建订货单",
        component: () => import("@/views/stockManage/ShopIndent/addIndent"),
      },
      {
        path: "editIndent",
        name: "编辑订货单",
        component: () => import("@/views/stockManage/ShopIndent/editIndent"),
      },
      {
        path: "indentDetail",
        name: "门店订货单详情",
        component: () => import("@/views/stockManage/ShopIndent/indentDetail"),
      },
    ],
  },
  // 批量新建订货批次
  {
    path: "/stockManage/StorePurchaseOrder/ExcleNewReceive",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import(
            "@/views/stockManage/StorePurchaseOrder/ExcleNewReceive/index"
          ),
      },
    ],
  },
  // 门店订货单 - 审核工作台
  {
    path: "/stockManage/StorePurchaseOrder/StorePurchaseOrderReviewList",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import(
            "@/views/stockManage/StorePurchaseOrder/StorePurchaseOrderReviewList/index"
          ),
      },
    ],
  },
  // 门店订货单 - 详细信息
  {
    path: "/stockManage/StorePurchaseOrder/PurchaseReviewDetailPage",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import(
            "@/views/stockManage/StorePurchaseOrder/PurchaseReviewDetailPage/index"
          ),
      },
    ],
  },
  // 生产计划单详情
  {
    path: "/stockManage/ProductionPlanList/ProductionDetails",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import(
            "@/views/stockManage/ProductionPlanList/ProductionDetails/index"
          ),
      },
    ],
  },
  // 钉钉推送规则详情页
  {
    path: "/cupboardMonitor/dingTalkPushRule/dingTalkPushConfigDetail",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import(
            "@/views/cupboardMonitor/dingTalkPushRule/dingTalkPushConfigDetail/index"
          ),
      },
    ],
  },
  // 编辑机器页面
  {
    path: "/recordManage/shopList/mac-set-page",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import("@/views/recordManage/shopList/mac-set-page/index"),
      },
    ],
  },
  // 联营编辑页
  {
    path: "/sell-manage/PartnerMerchantList/PartnerMerchantDetailPage",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import(
            "@/views/sell-manage/PartnerMerchantList/PartnerMerchantDetailPage/index"
          ),
      },
    ],
  },
  // 新建任务界面
  {
    path: "/giftCardManage/GiftCardBatchIssue/GiftCardBatchIssueAddTesk",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import(
            "@/views/giftCardManage/GiftCardBatchIssue/GiftCardBatchIssueAddTesk/index"
          ),
      },
    ],
  },
  {
    path: "/giftCardManage/GiftCardBatchIssue/GiftCardBatchIssueDetail",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import(
            "@/views/giftCardManage/GiftCardBatchIssue/GiftCardBatchIssueDetail/index"
          ),
      },
    ],
  },
  //  实体卡新建印卡任务
  {
    path: "/giftCardManage/PhysicalCard/PhysicalCardAddTask",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import(
            "@/views/giftCardManage/PhysicalCard/PhysicalCardAddTask/index"
          ),
      },
    ],
  },
  // 会员卡详情页
  {
    path: "/memberCard/manberManageList/manberManageDetailsPage",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import(
            "@/views/memberCard/manberManageList/manberManageDetailsPage/index"
          ),
      },
    ],
  },
  // 会员皮肤分类
  {
    path: "/shopOperate/groupsManagement/skinList/skinDetails",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import(
            "@/views/shopOperate/groupsManagement/skinList/skinDetails/index"
          ),
      },
    ],
  },
  // 新建编辑领奖活动
  {
    path: "/marketingActivities/rewardActive/rewardDetailPage",
    component: Layout,
    children: [
      {
        path: "index",
        component: () =>
          import(
            "@/views/marketingActivities/rewardActive/rewardDetailPage/index"
          ),
      },
    ],
  },
];
